import styled from 'styled-components';

export const FooterBox = styled.div`
    width: 100vw;
    height: 9.2vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    bottom: 0;
    margin-top: 7rem;
`;

export const Text = styled.span`
    font-size: 0.6rem;
    font-family: var(--korean);
    color: #767676;
    margin-left: 3.3vw;
    margin-right: 3.3vw;
`;
